import { ScaleSortOption } from '@rematter/frontend-lib-api-client';

import { ScaleRecord } from '../types/sidecar';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';
import { parseZonedDateTime } from '~/shared/utils/dateTime';

export const scalesListQueryAtom = createQueryAtomFactory(
  'settings.scalesList',
  (params: {
    ids?: string[];
    sidecarId?: string;
    limit?: number;
    offset?: number;
    sorting?: ScaleSortOption[];
  }) => ({
    scales: {
      __args: {
        filter: {
          ids: params.ids,
          sidecarId: params.sidecarId,
        },
        sorting: params.sorting,
        pagination: {
          limit: params.limit ?? 50,
          offset: params.offset ?? 0,
        },
      },
      entries: {
        id: true,
        sidecarId: true,
        name: true,
        connectionType: true,
        cameraId: true,
        scaleFormatType: true,
        measurementMode: true,
        status: true,
        online: true,
        lastSeenAt: true,
        sidecar: {
          id: true,
          name: true,
        },
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
      page: {
        total: true,
      },
    },
  }),
  {
    select: (data): { scales: ScaleRecord[]; totalCount: number } => {
      if (!data?.scales?.entries) {
        return { scales: [], totalCount: 0 };
      }

      return {
        scales: data.scales.entries.map((entry) => ({
          id: entry.id,
          sidecarId: entry.sidecarId,
          cameraId: entry.cameraId ?? null,
          name: entry.name,
          connectionType: entry.connectionType ?? '',
          serialPortPath: null,
          baudRate: null,
          dataBits: null,
          stopBits: null,
          parity: null,
          tcpHost: null,
          tcpPort: null,
          scaleFormatType: entry.scaleFormatType ?? '',
          measurementMode: entry.measurementMode ?? '',
          onDemandString: null,
          unitOfMeasurement: null,
          measurementIncrement: null,
          status: entry.status ?? 'Configured',
          online: entry.online ?? false,
          lastSeenAt: entry.lastSeenAt
            ? parseZonedDateTime(entry.lastSeenAt)
            : null,
          sidecar: entry.sidecar
            ? {
                id: entry.sidecar.id,
                name: entry.sidecar.name,
              }
            : null,
          timestamps: {
            createdAt: parseZonedDateTime(entry.timestamps.createdAt),
            updatedAt: parseZonedDateTime(entry.timestamps.updatedAt),
          },
        })),
        totalCount: data.scales.page?.total ?? 0,
      };
    },
  },
);
